<template>
  <div class="container">
    <div v-if="dataReady" class="questionnaireList">
      <div class="questionnaireHeader">
        <img src="../../assets/images/question4.jpg" alt="">
        <div class="title">{{question.title}}</div>
        <div class="summary" v-html="question.summary"></div>
      </div>
      <div class="questionnaireBody">
        <div class="question-list">
          <!-- <div class="question-title">{{item.questionname}}</div> -->
          <div class="Qranking-wrapper">
            <div class="Qranking-list" v-for="option in question.wjStatisticsBeanList" :key="option.id">
              <!-- <img v-if="option.logo" class="logo" :src="option.logo" alt=""> -->
              <div v-if="option.logo" class="logo" :style="{backgroundImage: 'url(' + option.logo + ')'}"></div>
              <div class="content">
                <div class="content_val" v-html="option.content"></div>
                <span class="more" @click.stop="seemore(option.content)">「查看详情」</span>
              </div>
              <div class="num">{{option.num}}票</div>
            </div>
          </div>
        </div>
      </div>
      <van-popup v-model="show" class="questionnaire_popup">
        <div class="questionnaire_popup_header">
          <van-icon name="cross" @click="closePopup" />
        </div>
        <div class="questionnaire_popup_body" v-html="nowShow"></div>
      </van-popup>
      <div class="questionnaireFooter">
        <van-button class="btn" color="#DB2D2D" @click="goBack">继续投票</van-button>
      </div>
    </div>
    <div class="loading" v-if="!dataReady">
      <van-loading type="spinner" color="#1989fa" size="50px" />
    </div>
  </div>
</template>

<script>
  import API from '../../interface/api'
  import wx from 'weixin-js-sdk'
  const u = navigator.userAgent
  import $ from 'jquery'
  export default {
    name: 'questionnaireRanking',
    data () {
      return {
        dataReady: true,
        show: false,
        nowShow: '',
        question: {}
      }
    },
    created () {
      this.$toast.allowMultiple()
      this.$fetch.get(API.QUESTIONNAIRERESULTLIST, {
        questionnaireid: this.$route.query.id
      }).then(res => {
        // console.log(res)
        this.question = res.data
        this.dataReady = true
        this.$nextTick(function () {
          $(".content").each(function(index, el) {
            if ($(el).height() > 120) {
              $(el).height(120)
              $(el).find('.more').show()
            }
          })
          if (u.indexOf('MicroMessenger') > -1) {
            var summary = this.$refs.summary ? this.$refs.summary.innerText.trim().replace(/\ +/g,"").replace(/[\r\n]/g,"").replace(/\s/g,"").substr(0, 50) : '广东科技报'
            this.$fetch.get(API.GETWECHATINVOKESIGN, {
              url: window.location.href
            }).then(response => {
              let data = response.data
              wx.config({
                debug: false,
                appId: data.appId, // 必填，公众号的唯一标识
                timestamp: data.timestamp, // 必填，生成签名的时间戳
                nonceStr: data.nonceStr, // 必填，生成签名的随机串
                signature: data.signature, // 必填，签名，见附录1
                jsApiList: ['onMenuShareTimeline', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              })
              wx.ready(function(){
                wx.updateAppMessageShareData({
                  title: res.data.title,
                  desc: summary,
                  link: window.location.href,
                  imgUrl: 'https://cdn-1300993597.cos.ap-guangzhou.myqcloud.com/image/common/gdkjb.jpg',
                  success: function() {
                    console.log('分享成功')
                  }
                })
                wx.updateTimelineShareData({
                  title: res.data.title,
                  link: window.location.href,
                  imgUrl: 'https://cdn-1300993597.cos.ap-guangzhou.myqcloud.com/image/common/gdkjb.jpg',
                  success: function() {
                    console.log('分享成功')
                  }
                })
                wx.onMenuShareWeibo({
                  title: res.data.title,
                  desc: summary,
                  link: window.location.href,
                  imgUrl: 'https://cdn-1300993597.cos.ap-guangzhou.myqcloud.com/image/common/gdkjb.jpg',
                  success: function() {
                    console.log('分享成功')
                  },
                  cancel: function(){
                    console.log('分享取消')
                  }
                })
              })
            })
          }
        })
      }).catch(error => {
        console.log(error)
      })
    },
    methods: {
      seemore (val) {
        this.nowShow = val
        this.show = true
        return false
      },
      closePopup () {
        this.show = false
      },
      goBack () {
        this.$router.push({
          path: '/questionnaire/list',
          query: {
            id: this.$route.query.id
          }
        })
      }
    }
  }
</script>

<style lang="stylus">
  
</style>